import { refreshProductInfo } from "../modules/Utils/loadProductInfo";

document.addEventListener('DOMContentLoaded', function() {
    const pageCategory = document.getElementById('product-category');
    const pageDetail = document.getElementById('product-detail');

    // productCategory js
    if (pageCategory) {}

    // productDetail js
    if (pageDetail) {
        // page setup
        const lightbox = GLightbox();

        setSwiperContainerMinHeight('.related')
        checkListHeight();

        function setSwiperContainerMinHeight(selector) {
            const container = document.querySelector(selector);
            if (!container) return;

            const slides = container.querySelectorAll('.swiper-slide');
            if (!slides.length) return;

            let maxHeight = 0;
            slides.forEach(slide => {
                const h = slide.offsetHeight;
                if (h > maxHeight) maxHeight = h;
            });

            const finalHeight = maxHeight + 68;
            container.style.minHeight = finalHeight + 'px';
        }

        function checkListHeight() {
            const list = document.querySelector('.lotes ul');
            if (!list) return

            const listHeight = list.offsetHeight;

            if (listHeight >= 350) {
                list.classList.add('break-row');
            }
        }

        // page swipers
        const swiperThumbs = new Swiper('.swiper-thumbs', {
            slidesPerView: 3,
            spaceBetween: 16,
            speed: 800,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
        })

        const swiperProduct = new Swiper('.swiper-product', {
            slidesPerView: 1,
            loop: true,

            thumbs: {
                swiper: swiperThumbs,
            },
        })

        const swiperDescription = new Swiper('.swiper-description', {
            slidesPerView: 1,
            spaceBetween: 12,
            autoHeight: true,
            speed: 800,

            pagination: {
                el: '.description .swiper-pagination',
                clickable: true,

                renderBullet: function (index, className) {
                    let slides = document.querySelectorAll('.swiper-description .swiper-slide');
                    let name = slides[index]?.getAttribute('data-name') || '';
                    return `<button class="${className}">${name}</button>`;
                },
            }
        })

        const swiperRelated = new Swiper('.swiper-related', {
            slidesPerView: "auto",
            spaceBetween: 40,
            loop: true,
            speed: 800,

            navigation: {
                prevEl: '.related .arrow-prev',
                nextEl: '.related .arrow-next',
            },
        })
    }

    // common js pages
    const swiperClients = new Swiper('.swiper-clients', {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 48,
        loop: true,
        speed: 800,
        cssMode: true,

        autoplay: {
            delay: 3000,
            disableOnInteraction: true,
        },
        navigation: {
            prevEl: '.clients-section .arrow-prev',
            nextEl: '.clients-section .arrow-next',
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
                spaceBetween: 24,
            },
            993: {
                slidesPerView: "auto",
                spaceBetween: 48,
            }
        }
    })
})

document.addEventListener('DOMContentLoaded', function() {
    const container = document.querySelector('.products--cards');
    const filtersOrder = document.querySelector('#asideOrder');
    const filtersCategory = document.querySelector('#asideProduct');
    const perPageDropdown = document.querySelector('#dropdownProductsFilter');
    const searchForm = document.querySelector('.search');
    const searchInput = document.querySelector('#searchInput');
    let currentPerPage = 24;

    const loader = document.createElement('div');
    loader.className = 'products-loader';
    loader.innerHTML = '<div class="spinner"></div>';
    loader.style.cssText = `
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.8);
        display: none;
        justify-content: center;
        align-items: center;
        z-index: 10;
    `;
    
    const spinnerStyle = document.createElement('style');
    spinnerStyle.textContent = `
        .products-loader .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #3498db;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }
        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }
    `;
    document.head.appendChild(spinnerStyle);
    container.style.position = 'relative';
    container.appendChild(loader);

    function showLoader() {
        loader.style.display = 'flex';
    }

    function hideLoader() {
        loader.style.display = 'none';
    }

    function loadProducts(page = 1) {
        showLoader();
        const url = new URL(window.location.href);
        const params = new URLSearchParams(url.search);

        // Lógica de ordenação atualizada
        const checkedOrder = document.querySelector('input[filter-type="order"]:checked');
        let orderBy = 'sort_order';
        let direction = 'asc';

        if (checkedOrder) {
            switch (checkedOrder.value) {
                case 'by-code':
                    orderBy = 'code';
                    break;
                case 'oferta':
                    orderBy = 'oferta';
                    break;
                case 'lancamento':
                    orderBy = 'lancamento';
                break;
                case 'mais_vendido':
                    orderBy = 'mais_vendido';
                break;
                case 'sort-desc':
                    orderBy = 'title';
                    direction = 'desc';
                    break;
                case 'sort-asc':
                    orderBy = 'title';
                    direction = 'asc';
                    break;
            }

        }

        // Subcategorias selecionadas
        const selectedSubcategories = Array.from(document.querySelectorAll('[name^="subcategory_"]:checked'))
            .map(chk => chk.getAttribute('subcategoryCode'));

        if (selectedSubcategories.length > 0) {
            params.set('subcategories', selectedSubcategories.join(','));
        } else {
            params.delete('subcategories');
        }

        // Marcas selecionadas
        const selectedClients = Array.from(document.querySelectorAll('[name^="client_"]:checked'))
            .map(chk => chk.getAttribute('clientCode'));

        if (selectedClients.length > 0) {
            params.set('clients', selectedClients.join(','));
        } else {
            params.delete('clients');
        }

        // Busca
        const search = searchInput?.value.trim();
        if (search) params.set('search', search);
        else params.delete('search');

        // Paginação e outros parâmetros
        params.set('page', page);
        params.set('order_by', orderBy);
        params.set('direction', direction);
        params.set('per_page', currentPerPage);

        // Requisição AJAX
        fetch(`${url.pathname}?${params.toString()}`, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(res => res.json())
        .then(data => {
            const row = container.querySelector('.row');
            row.innerHTML = data.html;
            
            container.querySelector('.products--bottom').innerHTML = data.pagination;
            attachPaginationEvents();
            if (typeof refreshProductInfo === 'function') {
                refreshProductInfo(row); 
            }

            hideLoader();
            const breadcrumb = document.querySelector('.breadcrumb');
            breadcrumb.scrollIntoView({ behavior: 'smooth', block: 'start' });
        })
        .catch(err => console.error('Erro ao carregar produtos:', err));
    }

    // Apenas um checkbox "order" pode ficar marcado
    document.querySelectorAll('input[filter-type="order"]').forEach(chk => {
        chk.addEventListener('change', e => {
            if (e.target.checked) {
                document.querySelectorAll('input[filter-type="order"]').forEach(other => {
                    if (other !== e.target) other.checked = false;
                });
            }
            loadProducts(1);
        });
    });

    function attachPaginationEvents() {
        document.querySelectorAll('.pagination button[data-page]').forEach(btn => {
            btn.addEventListener('click', e => {
                const page = e.currentTarget.getAttribute('data-page');
                if (page) loadProducts(page);
            });
        });
    }

    // Impede reload do form
    searchForm.addEventListener('submit', e => {
        e.preventDefault();
        loadProducts(1);
    });

    // Impede Enter de recarregar
    searchInput?.addEventListener('keydown', e => {
        if (e.key === 'Enter') {
            e.preventDefault();
            loadProducts(1);
        }
    });

    // Filtros de categoria (mantidos)
    filtersCategory.querySelectorAll('input[type="checkbox"]').forEach(chk => {
        chk.addEventListener('change', () => loadProducts(1));
    });

    // Filtros de marcas
    const filtersBrand = document.querySelector('#asideBrand');
    if (filtersBrand) {
        filtersBrand.querySelectorAll('input[type="checkbox"]').forEach(chk => {
            chk.addEventListener('change', () => loadProducts(1));
        });
    }

    // Dropdown "X itens"
    document.querySelectorAll('.dropdown-menu .dropdown-item').forEach(item => {
        item.addEventListener('click', e => {
            const perPageValue = e.currentTarget.getAttribute('perPage');
            currentPerPage = parseInt(perPageValue) || 9;
            perPageDropdown.innerText = `${currentPerPage} itens`;
            loadProducts(1);
        });
    });

    attachPaginationEvents();
});
